/**
 * Copyright 2016 xdot GmbH
 * Author: Carsten Bühler
 * Date: 22.03.2016
 *
 */

import { ClassNames as MapClassNames } from 'plugin/map-portlet';
import { AdministrativeRank } from '../Constants';

export const TerritoryRpLayer = {
    id: 'fliwas_territories_rp',
    uuid: 'fliwas_territories_rp',
    title: 'Regierungspräsidien',
    type: MapClassNames.LayerDataSource,
    typeKey: 'remote-vector-layer',
    params: {},
    config: {
        servicePath: '/o/vector-tiles?x={x}&y={y}&z={z}&filter=',
        filter: {
            "type": "TerritorialEntity",
            "administrativeRank": AdministrativeRank.RP,
        },
        style: {
            color: '#326487',
            fillColor: '#68869B',
        }
    }
};
export const TerritoryKreisLayer = {
    id: 'fliwas_territories_kreis',
    uuid: 'fliwas_territories_kreis',
    title: 'Kreise/Kreisfreie Städte',
    type: MapClassNames.LayerDataSource,
    typeKey: 'remote-vector-layer',
    params: {},
    config: {
        servicePath: '/o/vector-tiles?x={x}&y={y}&z={z}&filter=',
        filter: {
            "type": "TerritorialEntity",
            "administrativeRank": AdministrativeRank.DISTRICT,
        },
        style: {
            color: '#326487',
            fillColor: '#68869B',
        }
    }
};
export const TerritoryKommuneLayer = {
    id: 'fliwas_territories_kommune',
    uuid: 'fliwas_territories_kommune',
    title: 'Kommunen/Gemeinden',
    type: MapClassNames.LayerDataSource,
    typeKey: 'remote-vector-layer',
    params: {},
    config: {
        servicePath: '/o/vector-tiles?x={x}&y={y}&z={z}&filter=',
        filter: {
            "type": "TerritorialEntity",
            "administrativeRank": AdministrativeRank.COMMUNE,
        },
        style: {
            color: '#326487',
            fillColor: '#68869B',
        }
    }
};



// WEBPACK FOOTER //
// ./js/map/MapLayer.js